import { lazy } from 'react';

import { Route } from 'react-router-dom';

function Routers() {
  const Portrait = lazy(() => import('./pages/index'));
  const PortraitLoginMobile = lazy(() => import('./pages/login/mobile'));
  const PortraitLoginStudent = lazy(() => import('./pages/login/student'));
  const PortraitEnterpriseSimulate = lazy(
    () => import('./pages/enterprise/simulate')
  );

  const PortraitUserSimulate = lazy(() => import('./pages/user/Simulate'));
  const PortraitUserSimulateRecord = lazy(
    () => import('./pages/user/SimulateRecord')
  );
  const PortraitUserReport = lazy(() => import('./pages/user/Report'));
  const Interview = lazy(() => import('./pages/interview/Interview'));
  const ProcessFinish = lazy(() => import('./pages/process/ProcessFinish'));
  const LoginBindPosition = lazy(
    () => import('./pages/login/LoginBindPosition')
  );

  return [
    <Route key="h5" path="/h5" element={<Portrait />} />,
    <Route
      key="h5-login-mobile"
      path="/h5/login/mobile"
      element={<PortraitLoginMobile />}
    />,
    <Route
      key="h5-login-student"
      path="/h5/login/student"
      element={<PortraitLoginStudent />}
    />,
    <Route
      key="h5-enterprise-simulate"
      path="/h5/enterprise/simulate/:token/:only"
      element={<PortraitEnterpriseSimulate />}
    />,
    <Route
      key="h5-user-simulate"
      path="/h5/user/simulate/:type"
      element={<PortraitUserSimulate />}
    />,
    <Route
      key="h5-user-simulate-type-token"
      path="/h5/user/simulate/:type/:token"
      element={<PortraitUserSimulate />}
    />,
    <Route
      key="h5-user-simulate-record"
      path="/h5/simulate/:type/:token"
      element={<PortraitUserSimulateRecord />}
    />,
    <Route
      key="h5-user-report"
      path="/h5/report/:type/:token"
      element={<PortraitUserReport />}
    />,
    <Route path="/h5/interview/ai/:token" element={<Interview />} />,
    <Route path="/h5/process/:applicationToken" element={<ProcessFinish />} />,
    <Route path="/h5/login/:interviewToken" element={<LoginBindPosition />} />,
  ];
}

export default Routers;

//  <Route path="/simulate/:type" element={<AISimulateList />} />
//       <Route path="/simulate/:type/:token" element={<AISimulate />} />
//       <Route path="/report/:type/:token" element={<AIReport />} />
//       <Route path="/booking/:token" element={<BookingUrl />} />
